import React from 'react';

export const initialMembershipCardData = {
  header: {
    name: 'Non-Member',
    imageData: (<svg
      width="24"
      height="25"
      fill="none"
      className="membership-subscription-card__icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.75a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Z"
        stroke="#20A244"
        strokeWidth="1.5"
      />
      <path
        d="M5 21.5v-2.043c0-2.595 1.55-4.94 3.938-5.957v0M19 21.5v-2.043c0-2.595-1.55-4.94-3.938-5.957v0"
        stroke="#20A244"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>),
  },
  benefits: {
    price: null,
    list: null,
  },
  price: null,
  id: null,
};

export const defaultText = {
  youPrice: 'You price: £',
  checkboxLabel: 'I have a promocode',
  inputLabel: 'If you have a promocode, enter it here',
  btnText: 'Buy now',
};

export const renewalTypes = {
  annual: 'Annual',
  monthly: 'Monthly',
};

export const periodicity = {
  annual: 'year',
  monthly: 'month',
};

export const BOOKING_STORAGE_DATA = {
  BOOKING_DATA: 'booking_data',
  BOOKING_QUERY: 'booking_query',
};
